import http from "../http";
import Service from "../../Service";

export default class PresetService extends Service {
    list(productId, params) {
        return http.get(`admin/management/products/${productId}/presets`, {
            params,
            headers: this.getHeaders(),
        });
    }

    listProductIdsByProvider(providerId, params) {
        return http.get(`admin/providers/${providerId}/presets`, {
            params,
            headers: this.getHeaders(),
        });
    }

    create(productId, payload) {
        return http.post(`admin/management/products/${productId}/presets`, payload, {
            headers: this.getHeaders(),
        });
    }

    update(productId, presetId, payload) {
        return http.put(`admin/management/products/${productId}/presets/${presetId}`, payload, { headers: this.getHeaders() });
    }

    remove(productId, presetId) {
        return http.delete(`admin/management/products/${productId}/presets/${presetId}`, { headers: this.getHeaders() });
    }

    searchProviderProducts(providerId, name) {
        return http.get(`admin/providers/products`, {
            headers: this.getHeaders(),
            params: { provider_id: providerId, name },
        });
    }

    searchPackings(name) {
        return http.get(`commons/packings`, {
            headers: this.getHeaders(),
            params: { name },
        });
    }

    searchBrands(name) {
        return http.get(`commons/brands`, {
            headers: this.getHeaders(),
            params: { name },
        });
    }
}
